export const PatientSchedulingUserAccountOption: {
    New: "new";
    Existing: "existing";
    Unsure: "unsure";
} = {
    New: "new",
    Existing: "existing",
    Unsure: "unsure",
};

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EUserCondition {
    NewUser,
    ExistingPatient,
    ExistingAccountPatient,
}

export const PATIENT_SCHEDULING_TIMEOUT = new Error(
    "Scheduling expired. Please restart appointment booking.",
);

export const PATIENT_SCHEDULING_ENDPOINTS = {
    Accounts: "accounts",
    Locations: "locations",
    AppointmentTypes: "appointment_types",
    Practitioners: "practitioners",
    Schedules: "schedules",
    Appointments: "appointments",
    Address: "address",
};

export const PRACTITIONER_ID_SELCT_ALL_OPTIONS = {
    // the ids are negative to not interfere with the other practitioner Ids
    // no practitioner has been selected, show all available times
    showAllTimesOption: -1,
    // practitioner has been selected, select any practitioner with availability according to the selection algorithm
    programmaticPractitionerOption: -2,
};
